import { toast } from 'react-toastify';

export const notifyBySeverity = (message, severity = 'success') => {
  if (!message) return;

  if (severity === 'error') toast.error(message);
  else if (severity === 'warning') toast.warning(message);
  else if (severity === 'info') toast.info(message);
  else toast.success(message);
};

